import { render, staticRenderFns } from "./MyMedia.vue?vue&type=template&id=72ea20c2&scoped=true&"
import script from "./MyMedia.vue?vue&type=script&lang=js&"
export * from "./MyMedia.vue?vue&type=script&lang=js&"
import style0 from "./MyMedia.vue?vue&type=style&index=0&id=72ea20c2&scoped=true&lang=css&"
import style1 from "./MyMedia.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea20c2",
  null
  
)

export default component.exports